import { defineStore } from 'pinia'

interface State {
  baseUrl: string
}

export const useImageStore = defineStore('image', {
  // convert to a function
  state: (): State => ({
    baseUrl: 'https://api.photos-presse.com/image',
  }),

  getters: {},

  actions: {
    getOriginalPhotoUrl(key: string): string {
      return `${this.baseUrl}/photo/original/${key}`
    },

    getLogoUrl(key: string): string {
      return `${this.baseUrl}/logo/${key}`
    },

    getZipUrl(key: string): string {
      return `${this.baseUrl}/photo_zip/${key}`
    },

    getVideoThumbnailUrl(key: string): string {
      return `${this.baseUrl}/video_thumbnail/${key}`
    },

    // easily reset state using `$reset`
    clearUser() {
      this.$reset()
    },
  },
})
